module.exports = __webpack_public_path__ + "img/mobile-btn-on.673deec1.png";